// src/components/BankPosting/index.jsx
// ============================================================================
// BLOCK BP.PAGE.001 — Bank Posting page entry
// ----------------------------------------------------------------------------
// PURPOSE
// - Acts as the feature-local entry file for Bank Posting
// - Owns page-level title setup and outer padding
// - Delegates all real screen logic to BankPosting.jsx
//
// EDITING GUIDE
// - Keep this file intentionally thin
// - Page shell/layout belongs here
// - Feature behavior belongs in BankPosting.jsx or its controller/hooks
// ============================================================================

import React from 'react';

import Box from '@mui/material/Box';

import BankPosting from './BankPosting.jsx';

// ============================================================================
// BLOCK BP.PAGE.001.01 — Feature-local page component
// ----------------------------------------------------------------------------
// PURPOSE
// - Sets document title when the page mounts
// - Applies lightweight outer spacing around the main Bank Posting shell
// ============================================================================
export default function BankPostingPage() {
  React.useEffect(() => {
    document.title = 'Bank Posting';
  }, []);

  return (
    <Box sx={{ p: 2 }}>
      <BankPosting />
    </Box>
  );
}
